import Constants from 'common/constants'

import {REDUX_GET_SECTIONS} from '../../General/ActionTypes/ReduxActionTypes'
import {
  ADD_SECTION,
  DELETE_MANY_SECTIONS,
  DELETE_SECTION,
  GET_SECTION,
  GET_SECTIONS,
  UPDATE_SECTION,
} from './ActionTypes/ApiActionTypes'

export const getSection = (id, onSuccess, onFailure) => {
  return {
    type: GET_SECTION,
    payload: {
      apiUrl: Constants.api_get_section(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getSections = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_SECTIONS,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_sections,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: reduxUpdate ? REDUX_GET_SECTIONS : '',
      onFailure,
    },
  }
}
export const addSection = (body, onSuccess, onFailure) => {
  return {
    type: ADD_SECTION,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_add_section,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const deleteSection = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_SECTION,
    payload: {
      apiUrl: Constants.api_delete_section(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const deleteManySections = (ids, onSuccess, onFailure) => {
  return {
    type: DELETE_MANY_SECTIONS,
    payload: {
      apiUrl: Constants.api_delete_many_sections,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: {ids: ids},
      onSuccess,
      onFailure,
    },
  }
}
export const updateSection = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_SECTION,
    payload: {
      apiUrl: Constants.api_update_section(id),
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
